export default __webpack_public_path__ + "static/media/facebook-icon.97df0e90.svg";